import * as HLF from "html-living-framework";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {IMatch2ScreenData} from "../data/IMatch2ScreenData";
import {LocationPostcardLayout} from "../data/Location";
import {ButtonMute} from "../gameobjects/ButtonMute";
import {Envelope} from "../gameobjects/Envelope";
import {Keyboard} from "../gameobjects/Keyboard";
import {LocationBackground} from "../gameobjects/LocationBackground";
import {Postcard} from "../gameobjects/Postcard";
import {LocationBackgroundLayout_main} from "../layout/LocationBackgroundLayout";
import {AudioChannel} from "../managers/AudioChannel";

export class LoadScreen extends HLF.LoadScreen {

    public static readonly NAME = "LoadScreen";

    public readonly main = this.addChild(new Container());
    public readonly background = this.main.addChild(new LocationBackground());
    public postcard?: Postcard;
    public envelope?: Envelope;
    public readonly loader = this.addChild(new Sprite());
    public readonly buttonMute = this.addChild(new ButtonMute());

    private _onLoaded?: Callback;
    private _isAnimatedIn = false;
    private _screenData?: IMatch2ScreenData;
    private _bgm?: string;

    public init(pSize: PIXI.Point, pData?: IMatch2ScreenData) {
        super.init(pSize);

        LocationBackgroundLayout_main.call(this);
        this.main.scale.set(0.5);
        if (pData) {
            this._screenData = pData;
            if (pData.location) {
                this.background.setLocation(pData.location);
                this.background.zoomIn();
            }
            if (pData.envelope) {
                this.main.addChild(pData.envelope);
                this.envelope = pData.envelope;
                pData.envelope = undefined;
            }
            this._bgm = pData.bgm;
            pData.bgm = undefined;
        }

        this._isAnimatedIn = false;
        this._onLoaded = undefined;

        this.loader.setLayoutTexture("loader", 0.5, 0.5);
        this.loader.rotation = 0;
        this.loader.scale.set(0.75);
        this.loader.changeParent(this.main);
        if (this.envelope) {
            this.loader.x = this.envelope.x;
            this.loader.y = this.envelope.y + this.envelope.height;
        }

        this.loader.killTweens();
        this.loader.scaleFrom(0, 0.2, Ease.sineOut, () => {
            this.loader.delayedCall(0.4, () => {
                this._isAnimatedIn = true;
                this.hideLoader();
            });
        });
        this.loader.tweenTo(0.8, Ease.none, {
            rotation: -Math.PI * 2,
            repeat: -1,
        });

        Keyboard.clear();
        Keyboard.enabled = true;
        Keyboard.add(this.buttonMute);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        if (this.buttonMute) {
            this.buttonMute.setPosition(this._size);
        }
    }

    public onLoadComplete(pCallback: () => void): void {
        this._onLoaded = pCallback;
        if (this._screenData && this._bgm) {
            AudioChannel.BGM.stop();
            AudioChannel.BGM.play(this._bgm, "loop");
        }
        this.hideLoader();
    }

    private hideLoader() {
        if (this._isAnimatedIn && this._onLoaded) {
            this.loader.scaleTo(0, 0.2, Ease.sineIn, () => {
                this.loader.delayedCall(0.1, () => {
                    this.loader.killTweens();
                    const data = this._screenData;
                    if (data && this.envelope) {
                        this.postcard = this.main.addChild(new Postcard(data.location, data.level));
                        LocationPostcardLayout[data.location]![data.level]!.call(this);
                        this.envelope.open(this.postcard, () => {
                            this.callOnLoaded();
                        });
                    } else {
                        this.callOnLoaded();
                    }
                });
            });
        }
    }

    private callOnLoaded() {
        if (this._onLoaded) {
            this.main.destroyChildren();
            this._onLoaded();
        }
    }
}
